export const siteData = {
  PROXY_FETCH_URL: `${"https://justcors.com/l_469mqcqx9m/"}${
    process.env.GATSBY_PROXY_URL
  }?`,
}

export const features = {
  darmowe_wifi: "Darmowe WiFi",
  obsluga24: "Obsługa 24/7",
  monitoring24: "Monitoring 24/7",
  toaleta: "Toaleta",
  darmowy_transfer: "Darmowy Transfer",
  ogrodzony: "Ogrodzony",
  Oswietlenie_LED: "Oświetlenie LED",
  faktura_VAT: "Faktura VAT",
  ubezpieczony: "Ubezpieczony",
  dostepne_napoje: "Dostępne napoje",
  miejsca_dla_busow: "Miejsca dla busów",
  restauracja: "Restauracja",
  dozorowany: "Dozorowany",
  myjnia: "Myjnia samoch.",
}
// based on /slug
export const parking_features = {
  // parking-balice
  "/b1": [
    features.darmowe_wifi,
    features.darmowy_transfer,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ubezpieczony,
    features.obsluga24,
    features.toaleta,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/b1-zadaszony": [
    features.darmowe_wifi,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.faktura_VAT,
    features.Oswietlenie_LED,
  ],
  "/balicelot24": [
    features.miejsca_dla_busow,
    features.darmowy_transfer,
    features.obsluga24,
    features.faktura_VAT,
    features.ogrodzony,
    features.monitoring24,
  ],
  "/plusparking": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
  ],
  "/krakow-king": [
    features.dozorowany,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/parking-green-lotnisko-krakow": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/airpark": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.Oswietlenie_LED,
  ],
  "/vippark": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/oficjalny-krk": [
    features.ogrodzony,
    features.monitoring24,
    features.obsluga24,
    features.faktura_VAT,
  ],
  "/holiday-car-park": [
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.darmowe_wifi,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/victory-cars": [
    features.obsluga24,
    features.ogrodzony,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/odkryj-parking": [
    features.Oswietlenie_LED,
    features.monitoring24,
    features.ogrodzony,
    features.obsluga24,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/samolocik": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  // ParkVia
  "/darko-parking-balice-krakow": [
    features.ubezpieczony,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
  ],

  "/orange-parking-p3-balice-krakow": [
    features.ubezpieczony,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.miejsca_dla_busow,
    features.ubezpieczony,
  ],
  "/skyparkingbalice": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
  ],
  // parking-lotnisko-okecie
  "/szyszkowa-48": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.darmowy_transfer,
    features.ogrodzony,
    features.Oswietlenie_LED,
    features.miejsca_dla_busow,
  ],
  "/okecie-p4": [
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.ogrodzony,
  ],
  "/p2": [
    features.darmowe_wifi,
    features.ogrodzony,
    features.restauracja,
    features.faktura_VAT,
    features.obsluga24,
    features.monitoring24,
  ],

  "/holiday-parking": [
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/smart": [
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/Parking-Okecie-Poludnie": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowe_wifi,
    features.dostepne_napoje,
    features.darmowy_transfer,
    // features.kacik_dla_dzieci,
  ],
  "/Smile-Parking-Okecie": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowe_wifi,
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.myjnia,
  ],

  "/avt60": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowy_transfer,
    features.faktura_VAT,
    features.myjnia,
  ],
  "/dominik": [
    features.Oswietlenie_LED,
    features.monitoring24,
    features.ogrodzony,
    features.darmowy_transfer,
    features.obsluga24,
    features.faktura_VAT,
  ],
  "/VIP-PARKING-OKECIE": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.darmowy_transfer,
  ],
  "/rownolegla-1": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/odlot": [
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.toaleta,
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.myjnia,
  ],
  "/parking-business-class": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowy_transfer,
  ],
  "/Parking-Pieskowa-Skala": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.darmowy_transfer,
  ],
  "/Parking-Lotnisko-Okecie": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
  ],
  "/instalatorow": [
    features.dozorowany,
    features.monitoring24,
    features.ogrodzony,
    features.obsluga24,
    features.darmowy_transfer,
    features.darmowe_wifi,
    features.faktura_VAT,
  ],
  "/krispit": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/parkking": [
    features.darmowe_wifi,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
  ],
  "/propark": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
  ],
  "/parksist": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowy_transfer,
  ],
  "/auto-park-raszyn": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
  ],
  "/champion": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/premiere": [
    features.darmowe_wifi,
    features.ogrodzony,
    features.obsluga24,
    features.monitoring24,
  ],
  "/Oficjalny-Parking-Valet": [
    features.obsluga24,
    features.monitoring24,
    features.ubezpieczony,
    features.faktura_VAT,
  ],
  //ParkVia
  "/parking-dragon-warszawa": [
    features.darmowy_transfer,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.dostepne_napoje,
  ],
  "/parking-odlot-warszawa": [
    features.darmowy_transfer,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.toaleta,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/lider-parking-pod-skrzydlami-okecie": [
    features.darmowy_transfer,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.obsluga24,
    features.dostepne_napoje,
    features.faktura_VAT,
  ],
  "/start-parking-eko-warszawa-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/start-parking-plus-warszawa-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/start-parking-premium-warszawa-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/parkuj-lec-warszawa": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
    features.miejsca_dla_busow,
  ],
  "/air-park-chopin-p45": [
    features.darmowy_transfer,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.dozorowany,
    features.obsluga24,
  ],

  // parking-lotnisko-modlin
  "/jg-parking": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/bastion": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
    features.miejsca_dla_busow,
    features.Oswietlenie_LED,
    features.ubezpieczony,
    features.toaleta,
  ],
  "/modlinparking24": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/p38": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/carport": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/tani-i-bezpieczny": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
    features.miejsca_dla_busow,
    features.ubezpieczony,
    features.restauracja,
    features.myjnia,
  ],
  "/green-parking": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/parking-62": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/mpark": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/parkfly": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/perfect24": [
    features.obsluga24,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.darmowy_transfer,
  ],
  "/trip": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  // ParkVia
  "/parking-modlin-smart-tani-i-bezpieczny": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
    features.miejsca_dla_busow,
    features.ubezpieczony,
    features.restauracja,
    features.myjnia,
  ],
  "/alcatraz-parking-lotnisko-modlin": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.dozorowany,
    features.miejsca_dla_busow,
    features.ubezpieczony,
  ],
  "/avanti-park-modlin": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.toaleta,
  ],
  "/parking-solid-modlin": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/lider-parking-modlin": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.Oswietlenie_LED,
  ],
  "/orange-parking-modlin": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.Oswietlenie_LED,
  ],
  // parking-lotnisko-pyrzowice
  "/oficjalny-p1": [
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.ogrodzony,
  ],
  "/oficjalny-p2": [
    features.darmowe_wifi,
    features.obsluga24,
    features.faktura_VAT,
    features.ogrodzony,
  ],
  "/vip-garaze-megaparking": [
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.faktura_VAT,
  ],
  "/peri-garaze": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.ogrodzony,
    features.darmowy_transfer,
    features.ubezpieczony,
  ],
  "/garaze-parking-66": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/artlot2": [
    features.darmowe_wifi,
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/mtm": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.monitoring24,
    features.darmowe_wifi,
    features.obsluga24,
  ],
  "/startuj-z-nami": [
    features.Oswietlenie_LED,
    features.ubezpieczony,
    features.dozorowany,
    features.darmowe_wifi,
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.faktura_VAT,
  ],
  "/u-madzi-katowice": [
    features.darmowe_wifi,
    features.obsluga24,
    features.ubezpieczony,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/wiz-park": [
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.monitoring24,
  ],
  "/polonia": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.darmowe_wifi,
    features.ubezpieczony,
  ],
  "/peri": [
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.darmowe_wifi,
    features.ubezpieczony,
    features.faktura_VAT,
  ],
  "/travel": [
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
  ],
  /*
Startuj z Nami Pyrzowice
 Oświetlenie LED
 Ubezpieczony
 Dozorowany
 Dla samochodów osobowych
 Darmowe Wi-fi
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Faktura VAT
1.8 km
odległość od lotniska
4 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Polecany
zdjęcie A1 Rondo parking Pyrzowice     4.9 (627 opinii)
A1 Rondo Pyrzowice
 Dozorowany
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Ubezpieczony
 Faktura VAT
1.2 km
odległość od lotniska
3 min
transfer na lotnisko
120zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Polecany
zdjęcie PERI Parking parking Pyrzowice     4.9 (469 opinii)
PERI Parking Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Darmowe Wi-fi
 Ubezpieczony
 Faktura VAT
1.9 km
odległość od lotniska
5 min
transfer na lotnisko
90zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Polecany
zdjęcie MEGA Parking parking Pyrzowice     5 (1912 opinii)
MEGA Parking Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Faktura VAT
1.1 km
odległość od lotniska
4 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Polecany
zdjęcie Oficjalny parking P1 parking Pyrzowice     4.1 (104 opinii)
Oficjalny parking P1 Pyrzowice
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Brak transferu
 Dla samochodów osobowych
 przy terminalu
 Faktura VAT
0 km
odległość od lotniska
300zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Polecany
zdjęcie Port Pyrzowice parking PyrzowiceBrak opinii
Port Pyrzowice Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Oświetlenie LED
 Dla samochodów osobowych
 Darmowy transfer
 Faktura VAT
1.8 km
odległość od lotniska
4 min
transfer na lotnisko
120zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie U Madzi parking Pyrzowice     4.9 (1242 opinii)
U Madzi Pyrzowice
 Dla samochodów osobowych
 Darmowe Wi-fi
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Ubezpieczony
1.1 km
odległość od lotniska
3 min
transfer na lotnisko
130zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie VIP Garaże MEGA Parking parking Pyrzowice     4.9 (151 opinii)
VIP Garaże MEGA Parking Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Faktura VAT
1.1 km
odległość od lotniska
4 min
transfer na lotnisko
180zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie ArtLot 2 parking Pyrzowice     4.8 (943 opinii)
ArtLot 2 Pyrzowice
 Dla samochodów osobowych
 Darmowe Wi-fi
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Faktura VAT
2.2 km
odległość od lotniska
6 min
transfer na lotnisko
114zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Parking na 5 parking Pyrzowice     4.8 (75 opinii)
Parking na 5 Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Oświetlenie LED
 Toaleta
 Dla samochodów osobowych
 Darmowy transfer
1.4 km
odległość od lotniska
3 min
transfer na lotnisko
90zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie A1 parking Pyrzowice     4.9 (2240 opinii)
A1 Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Ubezpieczony
 Faktura VAT
1.2 km
odległość od lotniska
3 min
transfer na lotnisko
120zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie MTM parking Pyrzowice     4.7 (929 opinii)
MTM Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Ogrodzony
 Monitoring 24/7
 Darmowe Wi-fi
 Obsługa 24/7
2.5 km
odległość od lotniska
6 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Polonia parking Pyrzowice     5 (1971 opinii)
Polonia Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Monitoring 24/7
 Darmowe Wi-fi
 Ubezpieczony
1.3 km
odległość od lotniska
4 min
transfer na lotnisko
130zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Byczy parking parking Pyrzowice     4.9 (41 opinii)
Byczy parking Pyrzowice
 Oświetlenie LED
 Monitoring 24/7
 Ogrodzony
 Dla samochodów osobowych
 Obsługa 24/7
 Darmowy transfer
 Faktura VAT
2.7 km
odległość od lotniska
6 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie VIP Parking parking PyrzowiceBrak opinii
VIP Parking Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Oświetlenie LED
 Dla samochodów osobowych
 Darmowy transfer
0.6 km
odległość od lotniska
2 min
transfer na lotnisko
109zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie AAP-66 parking Pyrzowice     4.9 (588 opinii)
AAP-66 Pyrzowice
 Dla samochodów osobowych
 Dostępne napoje
 Darmowe Wi-fi
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Faktura VAT
2.2 km
odległość od lotniska
6 min
transfer na lotnisko
130zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie TRAVEL parking Pyrzowice     5 (189 opinii)
TRAVEL Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Ubezpieczony
2.1 km
odległość od lotniska
6 min
transfer na lotnisko
120zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Parking MARTOM parking PyrzowiceBrak opinii
Parking MARTOM Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Oświetlenie LED
 Dla samochodów osobowych
 Darmowy transfer
1.1 km
odległość od lotniska
3 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie PERI Parking Garaże Premium parking Pyrzowice     5 (45 opinii)
PERI Parking Garaże Premium Pyrzowice
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Darmowe Wi-fi
 Ubezpieczony
 Faktura VAT
1.9 km
odległość od lotniska
5 min
transfer na lotnisko
350zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie KTW Parking parking PyrzowiceBrak opinii
KTW Parking Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Dla samochodów osobowych
 Darmowy transfer
1.5 km
odległość od lotniska
5 min
transfer na lotnisko
100zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
Zapłać na miejscu
zdjęcie Parking Atmosfera parking PyrzowiceBrak opinii
Parking Atmosfera Pyrzowice
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Restauracja
 Dla samochodów osobowych
 Darmowy transfer
2.6 km
odległość od lotniska
6 min
transfer na lotnisko
90zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie WIZ-PARK parking Pyrzowice     5 (988 opinii)
WIZ-PARK Pyrzowice
 Oświetlenie LED
 Dla samochodów osobowych
 Darmowy transfer
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Ubezpieczony
2.3 km
odległość od lotniska
6 min
transfer na lotnisko
110zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Grand Parking parking PyrzowiceBrak opinii
Grand Parking Pyrzowice
 Dozorowany
 Obsługa 24/7
 Ogrodzony
 Monitoring 24/7
 Oświetlenie LED
 Dla samochodów osobowych
 Darmowy transfer
 Faktura/rachunek od parkingu
1.6 km
odległość od lotniska
6 min
transfer na lotnisko
100zł
za 7 dni
Darmowa anulacja 
Przedsiębiorca
zdjęcie Oficjalny Parking P2 parking Pyrzowice     4.5 (3049 opinii)
Oficjalny Parking P2 Pyrzowice
 Dla samochodów osobowych
 Brak transferu
 Darmowe Wi-fi
 Obsługa 24/7
 Ogrodzony
 Faktura VAT
0.6 km
odległość od lotniska
149zł
za 7 dni

  */
  "/a1-pyrzowice": [
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.faktura_VAT,
  ],
  "/a1-rondo": [
    features.dozorowany,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
  ],
  "/atmosfera": [
    features.restauracja,
    features.obsluga24,
    features.monitoring24,
    features.ogrodzony,
    features.darmowy_transfer,
  ],
  "/byczy-parking": [
    features.Oswietlenie_LED,
    features.monitoring24,
    features.ogrodzony,
    features.obsluga24,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/grand-parking": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/ktwparking": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.darmowy_transfer,
  ],
  "/martom": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
  ],
  "/mega-parking": [
    features.darmowy_transfer,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.faktura_VAT,
  ],
  "/parking-66": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/parking-na-5": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.toaleta,
    features.darmowy_transfer,
  ],
  "/port-pyrzowice": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.faktura_VAT,
  ],
  "/vip-ktw": [
    features.dozorowany,
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
  ],
  // ParkVia
  "/parking-lot-28-lotnisko-katowice": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/parking-23-katowice": [
    features.darmowy_transfer,
    features.monitoring24,
    features.obsluga24,
    features.ogrodzony,
  ],
  "/marko-parking-lotnisko-katowice": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.toaleta,
  ],
  "/parking-oaza-lotnisko-katowice": [
    features.darmowy_transfer,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
  ],
  "/start-parking-eko-katowice-pl-pl": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.ubezpieczony,
    features.toaleta,
  ],
  "/start-parking-plus-katowice-pl-pl": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.ubezpieczony,
    features.toaleta,
  ],
  // parking-lotnisko-rzeszow
  "/auto-park": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.monitoring24,
  ],
  "/park-and-fly-jasionka-rzeszow": [
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
  ],
  // parking-lotnisko-gdansk
  "/maxi-parking": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.ogrodzony,
    features.myjnia,
    features.faktura_VAT,
  ],
  "/parkingos": [
    features.obsluga24,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
  ],
  "/holiday-parking-gdansk": [
    features.ubezpieczony,
    features.dozorowany,
    features.dostepne_napoje,
    features.obsluga24,
    features.monitoring24,
    features.myjnia,
    features.darmowy_transfer,
    features.ogrodzony,
  ],
  "/goliat": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.obsluga24,
    features.monitoring24,
    features.myjnia,
    features.faktura_VAT,
  ],
  "/last-minute": [
    // P8
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.faktura_VAT,
    features.darmowy_transfer,
    features.obsluga24,
  ],
  "/sky-parking": [
    features.obsluga24,
    features.darmowy_transfer,
    features.myjnia,
    features.faktura_VAT,
  ],
  "/nawylocie": [
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.faktura_VAT,
    features.obsluga24,
    features.monitoring24,
  ],
  "/mega-park-service": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.ogrodzony,
  ],
  "/AutoAirportParking-Rebiechowo": [
    features.ogrodzony,
    features.monitoring24,
    features.obsluga24,
  ],
  "/odkryjparking-gdn": [
    features.dozorowany,
    features.ogrodzony,
    features.faktura_VAT,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
  ],
  "/minicity-rebiechowo": [
    features.ogrodzony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
    features.darmowy_transfer,
    features.ubezpieczony,
  ],
  //ParkVia
  "/smart-parking-lotnisko-gdansk": [
    features.darmowy_transfer,
    features.ubezpieczony,
    features.monitoring24,
    features.obsluga24,
  ],
  // parking-lotnisko-wroclaw
  "/pd": [
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.ogrodzony,
  ],
  "/graniczna-159": [
    features.darmowe_wifi,
    features.monitoring24,
    features.ogrodzony,
  ],
  "/parking-rondo": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.obsluga24,
    features.monitoring24,
  ],
  "/pod-zyrafa": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.faktura_VAT,
    features.obsluga24,
    features.monitoring24,
  ],
  "/parking-maro-wroclaw": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.obsluga24,
    features.monitoring24,
  ],
  "/wro-parking-abc": [features.obsluga24],
  // parking-lotnisko-lodz
  "/lotnisko-lodz": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ogrodzony,
  ],
  // parking-lotnisko-bydgoszcz-szwederowo
  "/jm-auto": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
    features.miejsca_dla_busow,
    features.ogrodzony,
    features.ubezpieczony,
    features.faktura_VAT,
  ],
  // parking-lotnisko-poznan
  "/oficjalny-p5": [
    features.ogrodzony,
    features.faktura_VAT,
    features.monitoring24,
    features.obsluga24,
  ],
  "/oficjalny-p4": [
    features.ogrodzony,
    features.faktura_VAT,
    features.monitoring24,
    features.obsluga24,
  ],
  "/valetparking": [
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
    features.ogrodzony,
  ],
  "/batorowska": [
    features.dostepne_napoje,
    features.darmowy_transfer,
    features.ogrodzony,
    features.ubezpieczony,
    features.darmowe_wifi,
    features.obsluga24,
    features.monitoring24,
  ],
  "/qparking": [
    features.obsluga24,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.ogrodzony,
    features.restauracja,
    features.darmowy_transfer,
  ],
  "/start-parking-eko-poznan-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/start-parking-plus-poznan-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  "/start-parking-premium-poznan-pl-pl": [
    features.darmowy_transfer,
    features.monitoring24,
    features.ubezpieczony,
    features.obsluga24,
    features.ogrodzony,
    features.dozorowany,
  ],
  // parking-lotnisko-lublin
  "/park24": [
    features.faktura_VAT,
    features.ogrodzony,
    features.darmowy_transfer,
    features.monitoring24,
    features.obsluga24,
  ],
  // parking-lotnisko-warszawa-radom
  "/parking-max": [
    features.darmowy_transfer,
    features.dozorowany,
    features.ogrodzony,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
  ],
  "/carport-radom": [
    features.darmowy_transfer,
    features.Oswietlenie_LED,
    features.dozorowany,
    features.ogrodzony,
    features.obsluga24,
    features.monitoring24,
    features.faktura_VAT,
  ],
  // < -- ZAGRANICZNE -- >
  // parking-lotnisko-brandenburg
  "/dein-stellplatz-BER": [
    features.darmowy_transfer,
    features.ogrodzony,
    features.monitoring24,
    features.Oswietlenie_LED,
    features.miejsca_dla_busow,
  ],
  // parking-lotnisko-frankfurt
  "/mein-valet-FRA": [
    features.obsluga24,
    features.monitoring24,
    features.ubezpieczony,
    features.dozorowany,
  ],
  "/mein-valet-P2-FRA": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
  ],
  "/mein-valet-P1-FRA": [
    features.darmowy_transfer,
    features.obsluga24,
    features.monitoring24,
  ],
  "/park-box-frankfurt": [
    features.monitoring24,
    features.myjnia,
    features.dozorowany,
    features.ubezpieczony,
    features.darmowy_transfer,
  ],
  "/parkparadies": [
    features.miejsca_dla_busow,
    features.dozorowany,
    features.myjnia,
    features.Oswietlenie_LED,
    features.monitoring24,
    features.ogrodzony,
    features.darmowy_transfer,
  ],
  // CZECHY
  // parking-lotnisko-brno
  "/letim-brno": [
    features.darmowy_transfer,
    features.obsluga24,
    features.dostepne_napoje,
    features.darmowe_wifi,
  ],
  // parking-lotnisko-praga
  "/smile-parking": [
    features.obsluga24,
    features.ogrodzony,
    features.monitoring24,
    features.ubezpieczony,
    features.Oswietlenie_LED,
    features.miejsca_dla_busow,
  ],
  // NIEMCY
  // parking-lotnisko-brandenburg
  "/dein-stellplatz-BER": [
    features.ogrodzony,
    features.Oswietlenie_LED,
    features.darmowy_transfer,
    features.monitoring24,
    features.miejsca_dla_busow,
  ],
  // parking-lotnisko-frankfurt
  "/mein-valet-FRA": [
    features.obsluga24,
    features.ubezpieczony,
    features.dozorowany,
    features.monitoring24,
  ],
  "/mein-valet-P2-FRA": [
    features.darmowy_transfer,
    features.monitoring24,
    features.obsluga24,
  ],
  "/mein-valet-P1-FRA": [
    features.darmowy_transfer,
    features.monitoring24,
    features.obsluga24,
  ],
  "/park-box-frankfurt": [
    features.monitoring24,
    features.dozorowany,
    features.myjnia,
    features.ubezpieczony,
  ],
  "/parkparadies": [
    features.miejsca_dla_busow,
    features.myjnia,
    features.monitoring24,
    features.darmowy_transfer,
    features.dozorowany,
    features.Oswietlenie_LED,
    features.ogrodzony,
  ],
  // HISZPANIA
  // parking-valencia
  "/Victoria-Parking-Valencia": [
    features.ubezpieczony,
    features.monitoring24,
    features.dozorowany,
    features.darmowy_transfer,
    features.myjnia,
    features.ogrodzony,
    features.obsluga24,
  ],
  // Malaga
  // parking-malaga-costa-del-sol
  "/low-cost-parking": [features.ogrodzony, features.myjnia],
  "/pedrocar": [features.darmowy_transfer, features.obsluga24],
  // parking-madrid-barajas
  "/park-sansecar": [
    features.ogrodzony,
    features.obsluga24,
    features.ubezpieczony,
    features.monitoring24,
  ],
  "/elite": [features.monitoring24, features.ogrodzony],
  "/pleyades": [
    features.monitoring24,
    features.ubezpieczony,
    features.ogrodzony,
    features.obsluga24,
  ],
  "/park-sansecar-valet": [
    features.ogrodzony,
    features.obsluga24,
    features.ubezpieczony,
    features.monitoring24,
  ],
  // parking-barcelona-el-prat
  "/park-and-greet": [features.ogrodzony, features.myjnia],
  // parking-alicante-elche
  "/odktyj-auto": [
    features.ubezpieczony,
    features.ogrodzony,
    features.darmowy_transfer,
    features.myjnia,
    features.monitoring24,
  ],
  "/monster": [features.ogrodzony, features.darmowy_transfer],
  "/Victoria-Parking": [
    features.ogrodzony,
    features.ubezpieczony,
    features.dozorowany,
    features.darmowy_transfer,
    features.myjnia,
    features.monitoring24,
    features.obsluga24,
  ],
}
// <<< ----------------------------------------------------------------------------- >>>>
export const parking_data = {
  // GATSBY_PARKING_SLUG
  "parking-balice": {
    excludedFeatures: [
      features.dozorowany,
      features.myjnia,
      features.miejsca_dla_busow,
      features.restauracja,
    ],
    // BALICE
    "/b1": {
      fromAirport: 0.8,
      transfer: 2,
      price: 49,
      days: 7,
    },
    "/b1-zadaszony": {
      fromAirport: 0.8,
      transfer: 2,
      price: 95,
      days: 7,
    },
    "/balicelot24": {
      fromAirport: 1.0,
      transfer: 3,
      price: 60,
      days: 7,
    },
    "/plusparking": {
      fromAirport: 1.9,
      transfer: 3,
      price: 48,
      days: 7,
    },
    "/krakow-king": {
      fromAirport: 1.2,
      transfer: 3,
      price: 55,
      days: 6,
    },
    "/parking-green-lotnisko-krakow": {
      fromAirport: 3.5,
      transfer: 4,
      price: 75,
      days: 6,
    },
    "/airpark": {
      fromAirport: 0.9,
      transfer: 2,
      price: 60,
      days: 6,
    },
    "/vippark": {
      fromAirport: 9.0,
      transfer: 14,
      price: 70,
      days: 6,
    },
    "/oficjalny-krk": {
      fromAirport: 0.1,
      transfer: 0,
      price: 120,
      days: 6,
    },
    "/holiday-car-park": {
      fromAirport: 2.0,
      transfer: 3,
      price: 95,
      days: 7,
    },
    "/victory-cars": {
      fromAirport: 1.5,
      transfer: 2,
      price: 120,
      days: 7,
    },
    "/odkryj-parking": {
      fromAirport: 0.9,
      transfer: 3,
      price: 95,
      days: 7,
    },
    "/samolocik": {
      fromAirport: 1.4,
      transfer: 3,
      price: 55,
      days: 7,
    },
    "/darko-parking-balice-krakow": {
      fromAirport: 0.1,
      transfer: 1,
      price: 140,
      days: 7,
    },
    "/orange-parking-p3-balice-krakow": {
      fromAirport: 1.0,
      transfer: 3,
      price: 125,
      days: 7,
    },
    "/skyparkingbalice": {
      fromAirport: 2.0,
      transfer: 5,
      price: 75,
      days: 7,
    },
  },
  "parking-lotnisko-okecie": {
    excludedFeatures: [features.dozorowany, features.myjnia, features.toaleta],
    "/szyszkowa-48": {
      fromAirport: 7.4,
      transfer: 13,
      price: 259,
      days: 7,
    },
    "/okecie-p4": {
      fromAirport: 0.0,
      transfer: 0,
      price: 440,
      days: 6,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/p2": {
      fromAirport: 0.0,
      transfer: 0,
      price: 699,
      days: 6,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/holiday-parking": {
      fromAirport: 5.0,
      transfer: 8,
      price: 260,
      days: 7,
    },
    "/smart": {
      fromAirport: 5.0,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/Parking-Okecie-Poludnie": {
      fromAirport: 10.0,
      transfer: 13,
      price: 259,
      days: 7,
    },
    "/Smile-Parking-Okecie": {
      fromAirport: 1.0,
      transfer: 3,
      price: 269,
      days: 7,
    },
    "/avt60": {
      fromAirport: 6.3,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/dominik": {
      fromAirport: 5.0,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/VIP-PARKING-OKECIE": {
      fromAirport: 3.0,
      transfer: 4,
      price: 275,
      days: 7,
    },
    "/rownolegla-1": {
      fromAirport: 5.2,
      transfer: 12,
      price: 259,
      days: 7,
    },
    "/odlot": {
      fromAirport: 5.2,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/parking-business-class": {
      fromAirport: 4.5,
      transfer: 10,
      price: 269,
      days: 7,
    },
    "/Parking-Pieskowa-Skala": {
      fromAirport: 3.0,
      transfer: 5,
      price: 269,
      days: 7,
    },
    "/Parking-Lotnisko-Okecie": {
      fromAirport: 5.0,
      transfer: 8,
      price: 265,
      days: 7,
    },
    "/instalatorow": {
      fromAirport: 4.2,
      transfer: 8,
      price: 259,
      days: 7,
    },
    "/krispit": {
      fromAirport: 5.0,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/parkking": {
      fromAirport: 5.0,
      transfer: 10,
      price: 259,
      days: 7,
    },
    "/propark": {
      fromAirport: 9.8,
      transfer: 12,
      price: 290,
      days: 7,
    },
    "/parksist": {
      fromAirport: 6.1,
      transfer: 12,
      price: 259,
      days: 7,
    },
    "/auto-park-raszyn": {
      fromAirport: 9.4,
      transfer: 13,
      price: 259,
      days: 7,
    },
    "/champion": {
      fromAirport: 4.8,
      transfer: 7,
      price: 165,
      days: 7,
    },
    "/premiere": {
      fromAirport: 3.8,
      transfer: 11,
      price: 150,
      days: 7,
    },
    "/Oficjalny-Parking-Valet": {
      fromAirport: 0.0,
      transfer: 0,
      price: 580,
      days: 6,
      customFeatures: ["⛔️ Samochód odbiera kierowca i odwozi na parking"],
    },
    // ParkVia
    "/parking-dragon-warszawa": {
      fromAirport: 3.4,
      transfer: 10,
      price: 229,
      days: 6,
    },
    "/parking-odlot-warszawa": {
      fromAirport: 2.6,
      transfer: 6,
      price: 239,
      days: 6,
    },
    "/lider-parking-pod-skrzydlami-okecie": {
      fromAirport: 1.8,
      transfer: 6,
      price: 249,
      days: 6,
    },
    "/start-parking-eko-warszawa-pl-pl": {
      fromAirport: 2.1,
      transfer: 10,
      price: 289,
      days: 6,
    },
    "/start-parking-plus-warszawa-pl-pl": {
      fromAirport: 2.1,
      transfer: 10,
      price: 309,
      days: 6,
    },
    "/start-parking-premium-warszawa-pl-pl": {
      fromAirport: 2.1,
      transfer: 10,
      price: 319,
      days: 6,
    },
    "/parkuj-lec-warszawa": {
      fromAirport: 2.9,
      transfer: 10,
      price: 299,
      days: 6,
    },
    "/air-park-chopin-p45": {
      fromAirport: 3.7,
      transfer: 8,
      price: 289,
      days: 6,
    },
  },
  // parking-lotnisko-modlin
  "parking-lotnisko-modlin": {
    excludedFeatures: [
      features.miejsca_dla_busow,
      features.restauracja,
      features.toaleta,
    ],
    "/jg-parking": {
      fromAirport: 2.8,
      transfer: 4,
      price: 90,
      days: 7,
    },
    "/bastion": {
      fromAirport: 3.2,
      transfer: 4,
      price: 90,
      days: 7,
    },
    "/modlinparking24": {
      fromAirport: 4.6,
      transfer: 3,
      price: 90,
      days: 7,
    },
    "/p38": {
      fromAirport: 3.9,
      transfer: 3,
      price: 95,
      days: 7,
    },
    "/carport": {
      fromAirport: 0.5,
      transfer: 1,
      price: 90,
      days: 7,
    },
    "/tani-i-bezpieczny": {
      fromAirport: 3.3,
      transfer: 3,
      price: 90,
      days: 7,
    },
    "/green-parking": {
      fromAirport: 3.9,
      transfer: 7,
      price: 90,
      days: 6,
    },
    "/parking-62": {
      fromAirport: 3.9,
      transfer: 3,
      price: 100,
      days: 7,
    },
    "/mpark": {
      fromAirport: 5.0,
      transfer: 6,
      price: 80,
      days: 7,
    },
    "/parkfly": {
      fromAirport: 5.1,
      transfer: 7,
      price: 55,
      days: 7,
    },
    "/perfect24": {
      fromAirport: 3.7,
      transfer: 5,
      price: 80,
      days: 7,
    },
    "/trip": {
      fromAirport: 1.6,
      transfer: 3,
      price: 75,
      days: 7,
    },
    // ParkVia
    "/parking-modlin-smart-tani-i-bezpieczny": {
      fromAirport: 2.9,
      transfer: 5,
      price: 69,
      days: 7,
    },
    "/alcatraz-parking-lotnisko-modlin": {
      fromAirport: 2.5,
      transfer: 6,
      price: 89,
      days: 7,
    },
    "/avanti-park-modlin": {
      fromAirport: 1.9,
      transfer: 5,
      price: 90,
      days: 7,
    },
    "/parking-solid-modlin": {
      fromAirport: 5.0,
      transfer: 5,
      price: 95,
      days: 7,
    },
    "/lider-parking-modlin": {
      fromAirport: 1.1,
      transfer: 2,
      price: 99,
      days: 7,
    },
    "/orange-parking-modlin": {
      fromAirport: 1.2,
      transfer: 2,
      price: 129,
      days: 7,
    },
  },
  "parking-lotnisko-pyrzowice": {
    excludedFeatures: [
      features.dozorowany,
      features.miejsca_dla_busow,
      features.restauracja,
      features.toaleta,
      features.myjnia,
    ],
    "/oficjalny-p1": {
      fromAirport: 0,
      transfer: 0,
      price: 69,
      days: 7,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/oficjalny-p2": {
      fromAirport: 0.3,
      transfer: 0,
      price: 69,
      days: 7,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/vip-garaze-megaparking": {
      fromAirport: 0.3,
      transfer: 2,
      price: 125,
      days: 6,
    },
    "/peri-garaze": {
      fromAirport: 0.9,
      transfer: 2,
      price: 150,
      days: 7,
    },
    "/garaze-parking-66": {
      fromAirport: 0.7,
      transfer: 2,
      price: 130,
      days: 7,
    },
    "/artlot2": {
      fromAirport: 0.8,
      transfer: 2,
      price: 65,
      days: 6,
    },
    "/mtm": {
      fromAirport: 0.4,
      transfer: 1,
      price: 70,
      days: 7,
    },
    "/startuj-z-nami": {
      fromAirport: 0.8,
      transfer: 2,
      price: 75,
      days: 6,
    },
    "/u-madzi-katowice": {
      fromAirport: 0.8,
      transfer: 3,
      price: 75,
      days: 7,
    },
    "/wiz-park": {
      fromAirport: 0.4,
      transfer: 1,
      price: 75,
      days: 7,
    },
    "/polonia": {
      fromAirport: 0.4,
      transfer: 1,
      price: 80,
      days: 7,
    },
    "/peri": {
      fromAirport: 0.9,
      transfer: 2,
      price: 80,
      days: 7,
    },
    "/travel": {
      fromAirport: 0.6,
      transfer: 2,
      price: 75,
      days: 6,
    },

    "/a1-pyrzowice": {
      fromAirport: 1.2,
      transfer: 3,
      price: 120,
      days: 7,
    },
    "/a1-rondo": {
      fromAirport: 1.2,
      transfer: 3,
      price: 120,
      days: 7,
    },
    "/atmosfera": {
      fromAirport: 2.6,
      transfer: 6,
      price: 90,
      days: 7,
    },
    "/byczy-parking": {
      fromAirport: 2.7,
      transfer: 6,
      price: 110,
      days: 7,
    },
    "/grand-parking": {
      fromAirport: 1.6,
      transfer: 6,
      price: 99,
      days: 7,
    },
    "/ktwparking": {
      fromAirport: 1.5,
      transfer: 5,
      price: 99,
      days: 7,
    },
    "/martom": {
      fromAirport: 1.1,
      transfer: 3,
      price: 110,
      days: 7,
    },
    "/mega-parking": {
      fromAirport: 1.1,
      transfer: 4,
      price: 110,
      days: 7,
    },
    "/parking-66": {
      fromAirport: 2.2,
      transfer: 6,
      price: 130,
      days: 7,
    },
    "/parking-na-5": {
      fromAirport: 1.4,
      transfer: 3,
      price: 90,
      days: 7,
    },
    "/port-pyrzowice": {
      fromAirport: 1.8,
      transfer: 4,
      price: 120,
      days: 7,
    },
    "/vip-ktw": {
      fromAirport: 0.6,
      transfer: 2,
      price: 109,
      days: 7,
    },
    // ParkVia
    "/parking-lot-28-lotnisko-katowice": {
      fromAirport: 0.5,
      transfer: 3,
      price: 130,
      days: 7,
    },
    "/parking-23-katowice": {
      fromAirport: 0.5,
      transfer: 2,
      price: 160,
      days: 7,
    },
    "/marko-parking-lotnisko-katowice": {
      fromAirport: 0.6,
      transfer: 2,
      price: 110,
      days: 7,
    },
    "/parking-oaza-lotnisko-katowice": {
      fromAirport: 1.2,
      transfer: 2,
      price: 100,
      days: 7,
    },
    "/start-parking-eko-katowice-pl-pl": {
      fromAirport: 1.4,
      transfer: 4,
      price: 114,
      days: 7,
    },
    "/start-parking-plus-katowice-pl-pl": {
      fromAirport: 1.4,
      transfer: 4,
      price: 129,
      days: 7,
    },
  },
  "parking-lotnisko-rzeszow": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.faktura_VAT,
      features.dostepne_napoje,
      features.miejsca_dla_busow,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
    ],
    "/auto-park": {
      fromAirport: 1.5,
      transfer: 5,
      price: 70,
      days: 7,
    },
    "/park-and-fly-jasionka-rzeszow": {
      fromAirport: 1,
      transfer: 2,
      price: 70,
      days: 6,
    },
  },
  "parking-lotnisko-gdansk": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.faktura_VAT,
      features.miejsca_dla_busow,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
    ],
    "/maxi-parking": {
      fromAirport: 0.8,
      transfer: 3,
      price: 75,
      days: 7,
    },
    "/parkingos": {
      fromAirport: 1.3,
      transfer: 3,
      price: 65,
      days: 7,
    },
    "/holiday-parking-gdansk": {
      fromAirport: 0.6,
      transfer: 2,
      price: 75,
      days: 7,
    },
    "/goliat": {
      fromAirport: 0.8,
      transfer: 3,
      price: 65,
      days: 7,
    },
    "/last-minute": {
      fromAirport: 0.6,
      transfer: 2,
      price: 79,
      days: 7,
      customFeatures: ["⛔️ Transfer na życzenie klienta"],
    },
    "/sky-parking": {
      fromAirport: 0.6,
      transfer: 2,
      price: 65,
      days: 7,
    },
    "/nawylocie": {
      fromAirport: 0.6,
      transfer: 2,
      price: 89,
      days: 7,
      customFeatures: ["⛔️ Transfer na życzenie klienta"],
    },
    "/mega-park-service": {
      fromAirport: 0.6,
      transfer: 2,
      price: 74,
      days: 7,
    },
    "/AutoAirportParking-Rebiechowo": {
      fromAirport: 0.4,
      transfer: 1,
      price: 59,
      days: 7,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/odkryjparking-gdn": {
      fromAirport: 0.7,
      transfer: 2,
      price: 95,
      days: 7,
    },
    "/minicity-rebiechowo": {
      fromAirport: 0.4,
      price: 58,
      days: 7,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/smart-parking-lotnisko-gdansk": {
      fromAirport: 0.8,
      transfer: 3,
      price: 99,
      days: 7,
    },
  },
  "parking-lotnisko-wroclaw": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.ubezpieczony,
      features.dostepne_napoje,
      features.miejsca_dla_busow,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
    ],
    "/pd": {
      fromAirport: 0,
      price: 180,
      days: 6,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/graniczna-159": {
      fromAirport: 0.5,
      price: 119,
      days: 6,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
    "/parking-rondo": {
      fromAirport: 1.1,
      transfer: 3,
      price: 119,
      days: 6,
    },
    "/pod-zyrafa": {
      fromAirport: 0.5,
      transfer: 1,
      price: 99,
      days: 6,
    },
    "/parking-maro-wroclaw": {
      fromAirport: 2.6,
      transfer: 6,
      price: 99,
      days: 6,
    },
    "/wro-parking-abc": {
      fromAirport: 0.3,
      transfer: 0,
      price: 199,
      days: 7,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
  },
  "parking-lotnisko-lodz": {
    excludedFeatures: [
      features.obsluga24,
      features.toaleta,
      features.Oswietlenie_LED,
      features.faktura_VAT,
      features.ubezpieczony,
      features.dostepne_napoje,
      features.miejsca_dla_busow,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.darmowe_wifi,
    ],
    "/lotnisko-lodz": {
      fromAirport: 1.1,
      transfer: 1,
      price: 109,
      days: 6,
      customFeatures: ["⛔️ Brak transferu na lotnisko"],
    },
  },
  "parking-lotnisko-bydgoszcz-szwederowo": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.faktura_VAT,
      features.ubezpieczony,
      features.dostepne_napoje,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.darmowe_wifi,
    ],
    "/jm-auto": {
      fromAirport: 2.6,
      transfer: 5,
      price: 100,
      days: 6,
    },
  },
  "parking-lotnisko-poznan": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.miejsca_dla_busow,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
    ],
    "/oficjalny-p5": {
      fromAirport: 0,
      price: 199,
      days: 7,
      customFeatures: ["🟥 Brak transferu"],
    },
    "/oficjalny-p4": {
      fromAirport: 0,
      price: 299,
      days: 7,
      customFeatures: ["🟥 Brak transferu"],
    },
    "/valetparking": {
      fromAirport: 0,
      price: 129,
      days: 7,
      customFeatures: ["🟥 Brak transferu"],
    },
    "/batorowska": {
      fromAirport: 1.6,
      transfer: 3,
      price: 50,
      days: 6,
    },
    "/qparking": {
      fromAirport: 4.3,
      transfer: 5,
      price: 149,
      days: 7,
    },
    "/start-parking-eko-poznan-pl-pl": {
      fromAirport: 4.1,
      transfer: 4,
      price: 129,
      days: 7,
    },
    "/start-parking-plus-poznan-pl-pl": {
      fromAirport: 4.1,
      transfer: 4,
      price: 139,
      days: 7,
    },
    "/start-parking-premium-poznan-pl-pl": {
      fromAirport: 4.1,
      transfer: 4,
      price: 149,
      days: 7,
    },
  },
  "parking-lotnisko-lublin": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.ubezpieczony,
      features.dostepne_napoje,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.darmowe_wifi,
      features.miejsca_dla_busow,
    ],
    "/park24": {
      fromAirport: 1.4,
      transfer: 2,
      price: 80,
      days: 7,
    },
  },
  "parking-lotnisko-warszawa-radom": {
    excludedFeatures: [
      features.toaleta,
      features.dostepne_napoje,
      features.miejsca_dla_busow,
    ],
    "/parking-max": {
      fromAirport: 0.7,
      transfer: 2,
      price: 110,
      days: 7,
    },
    "/carport-radom": {
      fromAirport: 3.0,
      transfer: 3,
      price: 110,
      days: 7,
    },
  },

  // << ---------------------------------- ZAGRANICZNE ---------------------------------- >>
  // CZECHY
  "parking-lotnisko-brno": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.ubezpieczony,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.miejsca_dla_busow,
      features.monitoring24,
      features.ogrodzony,
      features.faktura_VAT,
    ],
    "/letim-brno": {
      fromAirport: 2.7,
      transfer: 5,
      price: 180,
      days: 7,
    },
  },
  "parking-lotnisko-praga": {
    excludedFeatures: [
      features.toaleta,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.dostepne_napoje,
      features.darmowe_wifi,
      features.darmowy_transfer,
      features.faktura_VAT,
    ],
    "/smile-parking": {
      fromAirport: 0.1,
      transfer: 1,
      price: 250,
      days: 6,
      customFeatures: [
        "🟩 Samochód odbiera kierowca i odwozi na parking",
        "🟩 Samoobsługowy - brak transferu",
      ],
    },
  },
  // NIEMCY
  "parking-lotnisko-brandenburg": {
    excludedFeatures: [
      features.toaleta,
      features.ubezpieczony,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.faktura_VAT,
      features.darmowe_wifi,
      features.obsluga24,
      features.dostepne_napoje,
    ],
    "/dein-stellplatz-BER": {
      fromAirport: 7.0,
      transfer: 7,
      price: 490,
      days: 7,
    },
  },
  "parking-lotnisko-frankfurt": {
    excludedFeatures: [
      features.darmowe_wifi,
      features.toaleta,
      // features.Oswietlenie_LED,
      // features.ubezpieczony,
      features.restauracja,
      // features.dozorowany,
      // features.myjnia,
      // features.miejsca_dla_busow,
      // features.monitoring24,
      // features.ogrodzony,
      features.faktura_VAT,
      features.dostepne_napoje,
    ],
    "/mein-valet-FRA": {
      fromAirport: 0.0,
      transfer: 0,
      price: 599,
      days: 7,
      customFeatures: ["🟩 Brak transferu"],
    },
    "/mein-valet-P2-FRA": {
      fromAirport: 4.0,
      transfer: 6,
      price: 519,
      days: 6,
    },
    "/mein-valet-P1-FRA": {
      fromAirport: 5.0,
      transfer: 6,
      price: 379,
      days: 7,
    },
    "/park-box-frankfurt": {
      fromAirport: 9.9,
      transfer: 10,
      price: 399,
      days: 6,
      customFeatures: [
        "🟩 Samochód odbiera kierowca i odwozi na parking",
        "🟩 Samoobsługowy - brak transferu",
      ],
    },
    "/parkparadies": {
      fromAirport: 9.0,
      transfer: 10,
      price: 359,
      days: 7,
    },
  },
  // HISZPANIA
  "parking-Valencia": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.restauracja,
      features.miejsca_dla_busow,
      features.faktura_VAT,
      features.darmowe_wifi,
      features.dostepne_napoje,
    ],
    "/Victoria-Parking-Valencia": {
      fromAirport: 0.2,
      transfer: 2,
      price: 159,
      days: 7,
    },
  },
  "parking-malaga-costa-del-sol": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.ubezpieczony,
      features.restauracja,
      features.dozorowany,
      features.miejsca_dla_busow,
      features.monitoring24,
      features.faktura_VAT,
      features.dostepne_napoje,
      features.darmowe_wifi,
    ],
    "/low-cost-parking": {
      fromAirport: 0.4,
      transfer: 1,
      price: 199,
      days: 7,
    },
    "/pedrocar": {
      fromAirport: 1.0,
      transfer: 2,
      price: 199,
      days: 7,
    },
  },
  "parking-madrid-barajas": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.restauracja,
      features.dozorowany,
      features.myjnia,
      features.miejsca_dla_busow,
      features.faktura_VAT,
      features.darmowe_wifi,
      features.darmowy_transfer,
      features.dostepne_napoje,
    ],
    "/park-sansecar": {
      fromAirport: 0.0,
      transfer: 1,
      price: 229,
      days: 7,
      customFeatures: ["🟩 Samoobsługowy - brak transferu"],
    },
    "/elite": {
      fromAirport: 0.0,
      transfer: 0,
      price: 159,
      days: 7,
    },
    // "/pleyades": {
    //   fromAirport: 0.0,
    //   transfer: 0,
    //   price: 199,
    //   days: 7,
    // },
    "/park-sansecar-valet": {
      fromAirport: 6.7,
      transfer: 8,
      price: 249,
      days: 7,
      customFeatures: ["🟩 Samoobsługowy - brak transferu"],
    },
  },
  "parking-barcelona-el-prat": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.ubezpieczony,
      features.restauracja,
      features.dozorowany,
      features.miejsca_dla_busow,
      features.monitoring24,
      features.faktura_VAT,
      features.dostepne_napoje,
      features.darmowe_wifi,
      features.obsluga24,
      features.darmowy_transfer,
    ],
    "/park-and-greet": {
      fromAirport: 5.5,
      transfer: 8,
      price: 199,
      days: 7,
    },
  },
  "parking-alicante-elche": {
    excludedFeatures: [
      features.toaleta,
      features.Oswietlenie_LED,
      features.restauracja,
      features.faktura_VAT,
      features.darmowe_wifi,
      features.miejsca_dla_busow,
      features.dostepne_napoje,
    ],
    "/odktyj-auto": {
      fromAirport: 2.8,
      transfer: 5,
      price: 329,
      days: 6,
    },
    "/monster": {
      fromAirport: 5.0,
      transfer: 7,
      price: 99,
      days: 7,
    },
    "/Victoria-Parking": {
      fromAirport: 0.2,
      transfer: 2,
      price: 149,
      days: 7,
    },
  },
}

// export const slugs = [
//   "baliceparking.pl",
//   "parkingimodlin.pl",
//   "parkingchopina.pl",
//   "pyrzowiceparkingi.pl",
//   "wroclawparking.pl",
//   "gdanskparking.pl",
//   "lodzparking.pl",
//   "bydgoszczparking.pl",
//   "jasionkaparking.pl",
//   "parkingpoznanlotnisko.pl",
//   "lotniskolublinparking.pl",
// ]

export const websites_Polska = [
  {
    name: "Parking Bydgoszcz-Szwederowo",
    slug: "parking-lotnisko-bydgoszcz-szwederowo",
    url: "https://bydgoszczparking.pl",
  },
  {
    name: "Parking Gdańsk-Rębiechowo",
    slug: "parking-lotnisko-gdansk",
    url: "https://gdanskparking.pl",
  },
  {
    name: "Parking Katowice-Pyrzowice",
    slug: "parking-lotnisko-pyrzowice",
    url: "https://pyrzowiceparkingi.pl",
  },
  {
    name: "Parking Kraków-Balice",
    slug: "parking-balice",
    url: "https://baliceparking.pl",
  },
  {
    name: "Parking Lublin-Świdnik",
    slug: "parking-lotnisko-lublin",
    url: "https://lotniskolublinparking.pl",
  },
  {
    name: "Parking Łódź-Lublinek",
    slug: "parking-lotnisko-lodz",
    url: "https://lodzparking.pl",
  },
  {
    name: "Parking Poznań-Ławica",
    slug: "parking-lotnisko-poznan",
    url: "https://parkingpoznanlotnisko.pl",
  },
  {
    name: "Parking Rzeszów-Jasionka",
    slug: "parking-lotnisko-rzeszow",
    url: "https://jasionkaparking.pl",
  },
  {
    name: "Parking Olsztyn-Mazury",
    slug: "",
    url: "",
    disabled: true,
  },
  {
    name: "Parking Warszawa-Chopina",
    slug: "parking-lotnisko-okecie",
    url: "https://parkingchopina.pl",
  },
  {
    name: "Parking Warszawa-Modlin",
    slug: "parking-lotnisko-modlin",
    url: "https://parkingimodlin.pl",
  },
  {
    name: "Parking Warszawa-Radom",
    slug: "parking-lotnisko-warszawa-radom",
    url: "https://parkinglotniskoradom.pl",
  },
  {
    name: "Parking Wrocław-Strachowice",
    slug: "parking-lotnisko-wroclaw",
    url: "https://wroclawparking.pl",
  },
  {
    name: "Parking Zielona Góra-Babimost",
    slug: "",
    url: "",
    disabled: true,
  },
]

export const websites_Czechy = [
  {
    name: "Parking Brno",
    slug: "parking-lotnisko-brno",
    url: "https://parkinglotniskobrno.pl",
  },
  {
    name: "Parking Praga",
    slug: "parking-lotnisko-praga",
    url: "https://parkinglotniskopraga.pl",
  },
  {
    name: "Parking Karlovy vary",
    slug: "",
    url: "",
    disabled: true,
  },
  {
    name: "Parking Pardubice",
    slug: "",
    url: "",
    disabled: true,
  },
  {
    name: "Parking Ostrava",
    slug: "",
    url: "",
    disabled: true,
  },
]

export const websites_Hiszpania = [
  {
    name: "Parking Alicante-Elche",
    slug: "parking-alicante-elche",
    url: "https://parkinglotniskoalicante.pl",
  },
  {
    name: "Parking Barcelona El Prat",
    slug: "parking-barcelona-el-prat",
    url: "https://parkinglotniskobarcelona.pl",
  },
  {
    name: "Parking Madryt-Barajas",
    slug: "parking-madrid-barajas",
    url: "https://parkinglotniskomadryt.pl",
  },
  {
    name: "Parking Malaga Costa del Sol",
    slug: "parking-malaga-costa-del-sol",
    url: "https://parkinglotniskomalaga.pl",
  },
  {
    name: "Parking Walencja Manises",
    slug: "parking-Valencia",
    url: "https://parkinglotniskowalencja.pl",
  },
]

export const websites_Niemcy = [
  {
    name: "Parking Berlin Brandenburg",
    slug: "parking-lotnisko-brandenburg",
    url: "https://parkinglotniskoberlin.pl",
  },
  {
    name: "Parking Frankfurt nad Menem",
    slug: "parking-lotnisko-frankfurt",
    url: "https://parkinglotniskofrankfurt.pl",
  },
  {
    name: "Parking Hamburg",
    slug: "parking-lotnisko-hamburg",
    url: "https://parkinglotniskohamburg.pl",
    disabled: true,
  },
  {
    name: "Parking Kolonia/Bonn",
    slug: "parking-lotnisko-kolonia-bonn",
    url: "https://parkinglotniskokolonia.pl",
    disabled: true,
  },
]

export const all_websites = [
  ...websites_Polska,
  ...websites_Czechy,
  ...websites_Hiszpania,
  ...websites_Niemcy,
]

// you need to provide slugs not url
const websitesWithBlogSlug = [
  "parking-lotnisko-pyrzowice",
  "parking-balice",
  "parking-lotnisko-modlin",
]
export const websitesWithBlog = all_websites.filter(web =>
  websitesWithBlogSlug.includes(web.slug),
)

/*

niekatywne Niemcy
Parking Hamburg - Lotnisko Hamburg Niemcy parkinglotniskohamburg.pl
Parking Kolonia/Bonn- Lotnisko Kolonia/Bonn parkinglotniskokolonia.pl


// nieaktywne Czechy
Karlovy vary
Pardubice
Ostrava

nieaktywne - Austria
Wieden
*/
